import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
const colors = {
    gradientLiteBlue: 'bg-gradient-to-b from-gradient-lite-blue-from to-gradient-lite-blue-to',
    orange: 'bg-orange-100',
};
const sizes = {
    lg: {
        textClassName: 'w-[52px] top-[20px] left-[0px] text-[13px]',
        wrapperClassName: 'w-[72px] h-[72px]',
    },
    md: {
        textClassName: 'w-[32px] top-[9px] -left-[3px] text-[9px]',
        wrapperClassName: 'w-[40px] h-[40px]',
    },
    xl: {
        textClassName: 'w-[70px] top-[25px] left-[0px] text-[13px]',
        wrapperClassName: 'w-[88px] h-[88px]',
    },
};
export const TextObliqueBadge = (props) => {
    const { children, className = '', color, fontFamily, isBold, size = 'md', } = props;
    const topLeftTriangleStyle = css `
    clip-path: polygon(0 0, 100% 0%, 0% 100%);
  `;
    return (_jsx("div", Object.assign({ className: clsx('relative overflow-hidden', colors[color], sizes[size].wrapperClassName, className), css: topLeftTriangleStyle }, { children: _jsx("span", Object.assign({ className: clsx('block', 'text-center leading-none', 'absolute', '-rotate-45', 'z-20', sizes[size].textClassName) }, { children: _jsx(Text, Object.assign({ color: 'white', fontFamily: fontFamily, isBold: isBold, size: 'none', tagName: 'span' }, { children: children })) })) })));
};
